module.exports = __webpack_public_path__ + "img/__icon_CHŁODNIA.0e01842f.svg";